/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HostNameAndXmlLinkData } from './HostNameAndXmlLinkData';
import {
    HostNameAndXmlLinkDataFromJSON,
    HostNameAndXmlLinkDataFromJSONTyped,
    HostNameAndXmlLinkDataToJSON,
    HostNameAndXmlLinkDataToJSONTyped,
} from './HostNameAndXmlLinkData';

/**
 * 
 * @export
 * @interface ShoptetIntegrationInput
 */
export interface ShoptetIntegrationInput {
    /**
     * 
     * @type {Array<HostNameAndXmlLinkData>}
     * @memberof ShoptetIntegrationInput
     */
    hostNameAndXmlLinkList?: Array<HostNameAndXmlLinkData>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationInput
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationInput
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ShoptetIntegrationInput
     */
    refundedOrderStatuses?: Array<string>;
}

/**
 * Check if a given object implements the ShoptetIntegrationInput interface.
 */
export function instanceOfShoptetIntegrationInput(value: object): value is ShoptetIntegrationInput {
    return true;
}

export function ShoptetIntegrationInputFromJSON(json: any): ShoptetIntegrationInput {
    return ShoptetIntegrationInputFromJSONTyped(json, false);
}

export function ShoptetIntegrationInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShoptetIntegrationInput {
    if (json == null) {
        return json;
    }
    return {
        
        'hostNameAndXmlLinkList': json['hostNameAndXmlLinkList'] == null ? undefined : ((json['hostNameAndXmlLinkList'] as Array<any>).map(HostNameAndXmlLinkDataFromJSON)),
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
    };
}

export function ShoptetIntegrationInputToJSON(json: any): ShoptetIntegrationInput {
    return ShoptetIntegrationInputToJSONTyped(json, false);
}

export function ShoptetIntegrationInputToJSONTyped(value?: ShoptetIntegrationInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hostNameAndXmlLinkList': value['hostNameAndXmlLinkList'] == null ? undefined : ((value['hostNameAndXmlLinkList'] as Array<any>).map(HostNameAndXmlLinkDataToJSON)),
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
    };
}

